import styled from 'styled-components';
import {mediumMedia, mobileMedia} from '../../../../../../../globalVariables/GlobalVariables';
import {dFlex, dFlexCenter, alignCenter, justifyStart} from '../../../../../../../globalVariables/GlobalFlex';
import {getFontSize, getSpacing} from '@tickchak/react-share/app';
import zIndex from '../../../../../../../globalVariables/zIndex';

export const header = styled.div`
    ${dFlex}
    ${alignCenter}
    width: 100%;
    height: 40px;
    border: 1px solid var(--primitive-black-05);
    border-radius: ${getSpacing('spaceSm')};
    top: 0;
    z-index: ${zIndex.baseRaised};
    ${mobileMedia}{
        display: none;
    }
`;

export const cell = styled.div`
    ${dFlexCenter}
    flex: 1;
    max-width: 100px;
    min-width: 50px;
    height: 40px;
    text-align: center;
    font-size: ${getFontSize('caption')};
    line-height: 1.1;
    padding: ${getSpacing('spaceXxs')} ${getSpacing('spaceXs')};
    border-inline-start: 1px solid var(--primitive-black-05);
    white-space: pre-wrap;
`;

export const nameCell = styled(cell)`
    ${justifyStart}
    min-width: 200px;
    max-width: none;
    padding: 0 ${getSpacing('spaceMd')};
    font-size: ${getFontSize('body')};
    border-inline-start: none;
    ${mediumMedia}{
        min-width: 160px;
    }
`;
